import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useGetSlugAvailabilityMutation = createMutationHook(
  ShopsApiClient.getSlugAvailability,
  {
    mutationKey: ['getSlugAvailability'],
  },
)
